import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["maxVisibleItems", "size", "children", "iconPlacement", "itemTag", "tag", "theme", "mode", "activateFirstItemOnOpen", "wrapItemsWithLi"],
    _excluded2 = ["maxHeight", "leastMaxHeight"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useTheme, getInverseTheme } from '@rescui/ui-contexts';
import { Dropdown } from '@rescui/dropdown';
import { Menu } from '@rescui/menu';
import styles from './index.p.module.css.js';
var ITEM_HEIGHT_BY_SIZE = {
  s: 32,
  m: 40,
  l: 56
};
var SIZE_TO_CLASS = {
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};

var DropdownMenu = function DropdownMenu(_ref) {
  var _ref$maxVisibleItems = _ref.maxVisibleItems,
      maxVisibleItems = _ref$maxVisibleItems === void 0 ? 5 : _ref$maxVisibleItems,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      children = _ref.children,
      iconPlacement = _ref.iconPlacement,
      itemTag = _ref.itemTag,
      tag = _ref.tag,
      themeFromProps = _ref.theme,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'classic' : _ref$mode,
      _ref$activateFirstIte = _ref.activateFirstItemOnOpen,
      activateFirstItemOnOpen = _ref$activateFirstIte === void 0 ? false : _ref$activateFirstIte,
      wrapItemsWithLi = _ref.wrapItemsWithLi,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var itemHeight = ITEM_HEIGHT_BY_SIZE[size]; // half of item added to show that there is more items even if scroll bar hidden

  var maxHeight = (Math.ceil(maxVisibleItems) + 0.5) * itemHeight;

  var cleanMaxHeight = restProps.maxHeight,
      leastMaxHeight = restProps.leastMaxHeight,
      cleanedRestProps = _objectWithoutProperties(restProps, _excluded2); // cast to make runtime omit


  var theme = useTheme(themeFromProps);
  return /*#__PURE__*/React.createElement(Dropdown, _objectSpread(_objectSpread({}, cleanedRestProps), {}, {
    closeOnTab: true,
    mode: mode,
    theme: theme,
    leastMaxHeight: itemHeight,
    maxHeight: maxHeight,
    className: SIZE_TO_CLASS[size]
  }), /*#__PURE__*/React.createElement(Menu, {
    size: size,
    iconPlacement: iconPlacement,
    itemTag: itemTag,
    tag: tag,
    mode: mode === 'rock' ? 'rock' : 'classic',
    theme: mode === 'rock' ? getInverseTheme(theme) : theme,
    "data-test": "dropdown-menu",
    className: styles.menu,
    enableKeyboardNavigation: true,
    returnFocusOnUnmount: true,
    activateFirstItem: activateFirstItemOnOpen,
    wrapItemsWithLi: wrapItemsWithLi
  }, children));
};

export { DropdownMenu, DropdownMenu as default };
